import { Box, Typography, Button, Stack } from "@mui/material"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"

const Unauthorized = () => {
  const navigate = useNavigate()
  const { t } = useTranslation("common")

  return (
    <Box sx={{ textAlign: 'center', mt: 10 }}>
      <Typography variant="h4" color="error" gutterBottom>
        {t("unauthorizedCaution.title")}
      </Typography>
      <Typography variant="body1" gutterBottom sx={{ maxWidth: 640, mx: 'auto' }}>
        {t("unauthorizedCaution.message")}
      </Typography>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={2}
        justifyContent="center"
        sx={{ mt: 3 }}
      >
        <Button variant="contained" onClick={() => navigate("/admin-team/contact")}>
          {t("unauthorizedCaution.contactButton")}
        </Button>
      </Stack>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={2}
        justifyContent="center"
        sx={{ mt: 3 }}
      >
        <Button variant="outlined" onClick={() => navigate("/")}>
          {t("unauthorizedCaution.backToHome")}
        </Button>
      </Stack>
    </Box>
  )
}

export default Unauthorized
